export const UPSELL_DISPLAY_BY_PRODUCT = {
  CREAM: {
    name: 'The Cream',
    title: 'Rx Estriol Face Cream <br> with Tretinoin',
  },
  BLOSSOM: {
    name: 'Sildenafil Arousal Cream',
    title: 'Rx Sildenafil Arousal Cream',
  },
  MINOXIDIL: {
    name: 'The Serum',
    title: 'Minoxidil Hair Serum'
  },
  DEEPSLEEP: {
    name: 'Deep Sleep',
    title: 'Deep Sleep'
  }
}